import Organization from "./Organization";
import Signatory from "./Signatory";
import User from "./User";

export const enum SignatoryFormType {
  SELF = "self",
  CLEVER = "clever",
  CLEVERSTAFF = "cleverStaff",
  ZONEPARENTS = "zoneparents",
  MANUAL = "manual",
}

export type SignatoryGroup = {
  id?: string;
  organization: Organization;
  name: string;
  description: string;
  signatories: Signatory[];
  modifyingUser?: User;
  type: SignatoryFormType;
  grade?: string;
};
export default SignatoryGroup;
